


















































































import { Vue, Component } from "vue-property-decorator";

@Component({
  data: () => ({
    drawer: false,
    footer_msg: 
    `
      SOBRE NÓS <br/>
      SIM - <a href='https://sim.marica.rj.gov.br/' target="_blank">sim.marica.rj.gov.br</a><br/>
      Rua Álvares de Castro, nº 272 - Centro - Maricá - RJ | CEP 24901-355 <br/>
      Telefone: (21) 96810-2936 (somente Whatsapp) <br/>
      Horário de Funcionamento: Seg - Sex | 8h - 17h
    `
  }),
  methods: {
    openBannerLink() {
      window.open(
        "https://www.marica.rj.gov.br/category/coronavirus/",
        "_blank"
      );
    }
  }
})
export default class App extends Vue {}
